import Route from '@ember/routing/route';
import { service } from '@ember/service';

export default class AdminUserRolesNewRoute extends Route {
  // Services
  @service breadcrumb;

  // Hooks
  model() {
    return this.breadcrumb.findRouteModelOrCreateRecord('user-role');
  }

  afterModel(model) {
    this.breadcrumb.registerDetailRoute(model);
  }
}
